import {PaginatedResponseType} from "../../Types/Response/PaginatedResponseType";
import {InfiniteData} from "@tanstack/query-core/src/types";

const GetItemCounts = (data: InfiniteData<PaginatedResponseType>) => {
    let itemsLoaded = 0;
    data.pages.map((group: PaginatedResponseType) => itemsLoaded = itemsLoaded + group.data.length);

    return {loaded: itemsLoaded, total: data.pages[0].totalRecords };
}

const ArraysAreEqual = (a: Array<any>, b: Array<any>) => {
    if (a.length !== b.length) return false;

    a.sort();
    b.sort();

    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }

    return true;
}

const ArrayObjectsAreEqualByKey = (a: Array<any>, b: Array<any>, key: string) => {
    return a.filter(aItem =>
        !b.some(
            bItem => aItem[key] === bItem[key]
        )
    ).length !== 0;
}

export enum OperatingSystems {
    WIN = 'Windows',
    MAC = 'MacOS',
    UNIX = 'UNIX',
    LINUX = 'Linux',
    IOS = 'iOS',
    IPOS = 'iPadOS',
    DROID = 'Android',
    CHROMEOS = 'Chrome OS',
}

export enum Browsers {
    CHROME = 'Google Chrome',
    CHROMIUM = 'Chromium',
    FIREFOX = 'Mozilla Firefox',
    IE = 'Internet Explorer',
    EDGE = 'Edge',
    SAFARI = 'Safari',
    OPERA = 'Opera',
    VIVALDI = 'Vivaldi',
    BRAVE = 'Brave',
    SAMSUNG = 'Samsung Browser',
    YANDEX = 'Yandex Browser',
}

const CurrentOS = () : string => {
    let operatingSystem = 'Other';
    let details = navigator.userAgent.toLowerCase();

    //@ts-ignore
    if(navigator.userAgentData) {
        //@ts-ignore
        details = navigator.userAgentData.platform.toLowerCase();
    }

    if (details.indexOf('windows') !== -1) { operatingSystem = OperatingSystems.WIN }
    if (details.indexOf('mac') !== -1) { operatingSystem = OperatingSystems.MAC }
    if (details.indexOf('x11') !== -1) { operatingSystem = OperatingSystems.UNIX }
    if (details.indexOf('linux') !== -1) { operatingSystem = OperatingSystems.LINUX }
    if (details.indexOf('iphone os') !== -1) { operatingSystem = OperatingSystems.IOS }
    if (details.indexOf('ipad') !== -1) { operatingSystem = OperatingSystems.IPOS }
    if (details.indexOf('android') !== -1) { operatingSystem = OperatingSystems.DROID }
    if (details.indexOf('cros') !== -1) { operatingSystem = OperatingSystems.CHROMEOS }

    return operatingSystem;
}

const CurrentBrowser = () : string => {
    let currentBrowser = 'Other';
    let details = navigator.userAgent.toLowerCase();

    if (details.indexOf('chrome') !== -1) { currentBrowser = Browsers.CHROME }
    else if (details.indexOf('chromium') !== -1) { currentBrowser = Browsers.CHROMIUM }
    else if (details.indexOf('firefox') !== -1 || details.indexOf('fxios') !== -1) { currentBrowser = Browsers.FIREFOX }
    else if (details.indexOf('msie') !== -1 || details.indexOf('trident') !== -1) { currentBrowser = Browsers.IE }
    else if (details.indexOf('edg/') !== -1 || details.indexOf('edgios/') !== -1 || details.indexOf('edga/') !== -1) { currentBrowser = Browsers.EDGE }
    else if (details.indexOf('safari') !== -1) { currentBrowser = Browsers.SAFARI }
    else if (details.indexOf('opr') !== -1) { currentBrowser = Browsers.OPERA }
    else if (details.indexOf('vivaldi') !== -1) { currentBrowser = Browsers.VIVALDI }
    else if (details.indexOf('brave') !== -1) { currentBrowser = Browsers.BRAVE }
    else if (details.indexOf('samsung') !== -1) { currentBrowser = Browsers.SAMSUNG }
    else if (details.indexOf('YaBrowser') !== -1) { currentBrowser = Browsers.YANDEX }


    return currentBrowser;
}

export { GetItemCounts, ArraysAreEqual, ArrayObjectsAreEqualByKey, CurrentOS, CurrentBrowser }